import { useMediaQuery } from "@material-ui/core";
import React from "react";
import {
	AutocompleteInput,
	Filter,
	ReferenceInput,
	SelectInput,
	useTranslate,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import SearchInput from "../components/inputs/SearchInput";
import { usersConfig } from "../users";

const StatusInput = (props) => {
	const translate = useTranslate();
	const statuses = ["active", "suspended", "with_users", "without_users"];
	const choices = statuses.map((status) => ({
		id: status,
		name: translate(`resources.bookmaker-channels.status.${status}`),
	}));
	return <SelectInput {...props} choices={choices} />;
};

const Filters = (props) => {
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<Filter {...props} variant="outlined">
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn={!sm}
				fullWidth
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<StatusInput
				allowEmpty
				emptyText="ra.action.all"
				source="status"
				alwaysOn
				fullWidth
			/>
			<ReferenceInput
				source="user_id"
				reference="users"
				alwaysOn={!sm}
				fullWidth
				{...usersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
		</Filter>
	);
};
export default Filters;
